import React from "react";

/**
 * Tablo aksiyon butonu — yeni nesil temiz ikon buton (soft renkli).
 */
const ColumnButton = ({
  buttonType,
  onClick,
  custombutton,
}: {
  buttonType: "edit" | "delete" | "details" | "custom";
  onClick: () => void;
  custombutton?: {
    color?: string;
    text?: string;
  };
}) => {
  if (buttonType === "edit")
    return (
      <button type="button" className="m-actbtn m-actbtn--edit" onClick={onClick} title="Düzenle">
        <i className="mdi mdi-pencil-outline" />
      </button>
    );
  if (buttonType === "delete")
    return (
      <button type="button" className="m-actbtn m-actbtn--danger" onClick={onClick} title="Sil">
        <i className="mdi mdi-trash-can-outline" />
      </button>
    );
  if (buttonType === "details")
    return (
      <button type="button" className="m-actbtn m-actbtn--view" onClick={onClick} title="Detay">
        <i className="mdi mdi-eye-outline" />
      </button>
    );
  if (buttonType === "custom" && custombutton)
    return (
      <button
        type="button"
        className="m-actbtn m-actbtn--custom"
        style={custombutton.color ? { color: custombutton.color } : undefined}
        onClick={onClick}
      >
        {custombutton.text}
      </button>
    );
  return null;
};
export default ColumnButton;
